
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/party-tent-rental",
      function () {
        return require("private-next-pages/party-tent-rental.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/party-tent-rental"])
      });
    }
  